import script from "./powerStationSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationSetting.vue?vue&type=script&setup=true&lang=js"

import "./powerStationSetting.vue?vue&type=style&index=0&id=0fe60fe3&lang=less"

const __exports__ = script;

export default __exports__